import { useAppSelector } from "lib/redux";
import { selectMe } from "domains/account";
import { useMemo } from "react";
import { PermissionLevels } from "lib/types";

const hasRequiredRole = (
  allowedRoles: PermissionLevels[],
  userRole: PermissionLevels | null
): boolean => {
  if (!userRole) {
    return false;
  }

  const findRole = allowedRoles.findIndex((role) => (
    role.toLocaleUpperCase() === userRole.toLocaleUpperCase()
  ));
  return findRole >= 0;
}

export const useComponentAccess = (allowedRoles: PermissionLevels[]) => {
  const { permissions = null } = useAppSelector(selectMe);

  const hasAccess = useMemo(
    () => hasRequiredRole(allowedRoles, permissions),
    [allowedRoles, permissions]
  );

  return {
    hasAccess,
  }
};
